export const getPassengerBulkSendMessagePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/passengers/bulk/send-message-to-passengers`;

export const getPassengerBulkRidesParticipationPreviewPath = (
  companyId: number,
): string =>
  `/api/v1/core/c/${companyId}/passengers/bulk/rides-participation-preview`;

export const getBulkPassengersStationMapDataPath = (
  companyId: number,
): string =>
  `/api/v1/core/c/${companyId}/passengers/bulk/fetch-map-stations-data`;

export const getBulkSetPassengersNearByStationPath = (
  companyId: number,
): string =>
  `/api/v1/core/c/${companyId}/passengers/bulk/set-passengers-nearest-station`;

export const getBulkRecalculateWalkingDistancePath = (
  companyId: number,
): string =>
  `/api/v1/core/c/${companyId}/passengers/bulk/recalculate-walking-distance`;

export const getRecalculateWalkingDistancePath = (
  companyId: number,
  passengerId: number,
): string =>
  `/api/v1/core/c/${companyId}/passengers/${passengerId}/recalculate-walking-distance`;

export const getBulkActivateShiftTemplatePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/passengers/bulk/activate-shift-template`;
export const getPassengersPhonesInUsePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/passengers/phones-in-use`;
